/**
 * React Query Keys Factory
 * Centralized query keys for type-safe queries
 *
 * Pattern: [domain, ...identifiers, ...filters]
 * Example: ['users', userId, { status: 'active' }]
 */

export const queryKeys = {
  // User queries
  user: {
    all: ['user'] as const,
    profile: () => [...queryKeys.user.all, 'profile'] as const,
    apps: () => [...queryKeys.user.all, 'apps'] as const,
  },

  // Health checks
  health: {
    all: ['health'] as const,
    status: () => [...queryKeys.health.all, 'status'] as const,
  },
} as const;

/**
 * Type helper to extract query key type
 */
export type QueryKeys = typeof queryKeys;
